import EnumType from "@/app/shared/EnumType.js";

const values = {
  Reserve: 0, 
  Monthly: 1
};

export default EnumType.generate(values, "GradeControl.NSRForecastType.");